<template>
  <div class="submit-resume">
    <div class="header">
      <div class="wantPost">我要应聘</div>
      <div class="position">应聘职位：{{submitOfficeDetail.Fname}}</div>
    </div>
    <form action="/api/recruit/resume" ref="formRef">
      <input type="hidden" name="Fjobid" :value="submitOfficeDetail.Fjobid">
      <div class="baseinfo">
        <div class="w_half">
          <div><label for="Fname">姓　　名</label><input type="text" name="Fname" id="Fname" class="focusText" :class="{error: ruleObj.FnameStatus}" placeholder="请输入您的姓名" v-model="submitForm.Fname" @blur="checkRules('Fname')" @input="checkRules('Fname')">
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FnameStatus">请正确输入姓名</div>
            </transition>
          </div>
          <div><label for="Fmail">电子邮箱</label><input type="text" name="Fmail" id="Fmail" class="focusText" :class="{error: ruleObj.FmailStatus}" placeholder="请输入您的电子邮箱" v-model="submitForm.Fmail" @blur="checkRules('Fmail')" @input="checkRules('Fmail')">
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FmailStatus">请正确输入电子邮箱</div>
            </transition>
          </div>
          <div><label for="Fprovince">所在省市</label><select name="Fprovince" id="Fprovince" class="focusText" :class="{error: ruleObj.FlocationStatus}" v-model="submitForm.Fprovince" @change="FprovinceChange">
              <option value='' disabled selected v-show="submitForm.Fprovince===''">请选择</option>
              <option :value="index" v-for="(item,index) in provinceList" :key="index">{{item}}</option>
            </select>省<select name="Fcity" id="Fcity" class="focusText" :class="{error: ruleObj.FlocationStatus}" v-model="submitForm.Fcity" @change="checkRules('Flocation')">
              <option value='' disabled selected v-show="submitForm.Fcity===''">请选择</option>
              <option :value="index" v-for="(item,index) in cityList" :key="index">{{item}}</option>
            </select>市<transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FlocationStatus">请选择省市</div>
            </transition>
          </div>
          <div style="margin-bottom: 0"><label for="Fschool">毕业院校</label><input type="text" name="Fschool" id="Fschool" class="focusText" :class="{error: ruleObj.FschoolStatus}" placeholder="请输入您的毕业院校" v-model="submitForm.Fschool" @blur="checkRules('Fschool')" @input="checkRules('Fschool')">
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FschoolStatus">请正确输入毕业院校</div>
            </transition>
          </div>
        </div>
        <div class="w_half">
          <div><label for="Fphone">手　　机</label><input type="text" name="Fphone" id="Fphone" class="focusText" :class="{error: ruleObj.FphoneStatus}" placeholder="请输入您的手机号" v-model="submitForm.Fphone" @blur="checkRules('Fphone')" @input="checkRules('Fphone')">
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FphoneStatus">请正确输入手机</div>
            </transition>
          </div>
          <div><label for="Feducation">学　　历</label><select name="Feducation" id="Feducation" class="focusText" :class="{error: ruleObj.FeducationStatus}" v-model="submitForm.Feducation" @change="checkRules('Feducation')">
              <option value='' disabled selected v-show="submitForm.Feducation===''">请选择</option>
              <option :value="2">大专</option>
              <option :value="3">本科</option>
              <option :value="4">硕士</option>
              <option :value="5">博士</option>
            </select>
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FeducationStatus">请选择学历</div>
            </transition>
          </div>
          <div><label for="Fworkplace">意向工作地点</label><select name="Fworkplace" id="Fworkplace" class="focusText" :class="{error: ruleObj.FworkplaceStatus}" v-model="submitForm.Fworkplace" @change="checkRules('Fworkplace')">
              <option value='' disabled selected v-show="submitForm.Fworkplace===''">请选择</option>
              <option :value="1" v-show="submitOfficeDetail.Fworkplace.indexOf('1')>-1">深圳市</option>
              <option :value="2" v-show="submitOfficeDetail.Fworkplace.indexOf('2')>-1">广州市</option>
            </select>
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FworkplaceStatus">请选择选择意向工作地点</div>
            </transition>
          </div>
          <div style="margin-bottom: 0"><label for="Fmajor">专　　业</label><input type="text" name="Fmajor" id="Fmajor" class="focusText" :class="{error: ruleObj.FmajorStatus}" v-model="submitForm.Fmajor" placeholder="请输入您的专业" @blur="checkRules('Fmajor')" @input="checkRules('Fmajor')">
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FmajorStatus">请正确输入专业</div>
            </transition>
          </div>
        </div>
      </div>
      <div class="expInfo">
        <div class="resume-type">
          <label for="FresumeType">个人简历：</label>
          <div class="radio" :class="{active: submitForm.FresumeType=='online'}"><input type="radio" name="FresumeType" value="online" v-model="submitForm.FresumeType" style="cursor: pointer;"><span @click="submitForm.FresumeType='online'" style="cursor: pointer;">在线简历</span>
          </div>
          <div class="radio" :class="{active: submitForm.FresumeType=='extfile'}"><input type="radio" name="FresumeType" value="extfile" v-model="submitForm.FresumeType" style="cursor: pointer;"><span @click="submitForm.FresumeType='extfile'" style="cursor: pointer;">附件简历</span>
          </div>
          <span style="font-size: 16px;color: #f56c6c;position:relative;top:0px;left:-30px;line-height: 36px;">（建议：优先选择 #附件简历# 方式投递岗位）</span>
        </div>
        <div v-show="submitForm.FresumeType == 'online'" class="online-resume">
          <div v-show="submitOfficeDetail.Fnature === 1">
            <label for="Fworkexp">工作经历：</label><textarea name="Fworkexp" id="Fworkexp" :placeholder="'此处请填写您的工作经历，如：\n1、2017年6月-2017年8月，在XXX公司，担任XXX一职，主要工作内容是XXX，取得XXX成果。\n2、2018年6月-2018年8月，在XXX公司，担任XXX一职，主要工作内容是XXX，取得XXX成果。\n注意：如没有，请填写无'" class="focusText" :class="{error: ruleObj.FworkexpStatus}" v-model="submitForm.Fworkexp" @blur="checkRules('Fworkexp')" @input="checkRules('Fworkexp')"></textarea>
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FworkexpStatus">请输入工作经历</div>
            </transition>
          </div>
          <div v-show="submitOfficeDetail.Fnature > 1">
            <label for="Finternnexp">实习经历：</label><textarea name="Finternnexp" id="Finternnexp" :placeholder="'此处请填写您的实习经历，如：\n1、2017年6月-2017年8月，在XXX公司实习，主要工作内容是XXX，学到了XXX，取得XXX成果。\n2、2018年6月-2018年8月，在XXX公司实习，主要工作内容是XXX，学到了XXX，取得XXX成果。\n注意：如没有，请填写无'" class="focusText" :class="{error: ruleObj.FinternnexpStatus}" v-model="submitForm.Finternnexp" @blur="checkRules('Finternnexp')" @input="checkRules('Finternnexp')"></textarea>
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FinternnexpStatus">请输入实习经历</div>
            </transition>
          </div>
          <div v-show="submitOfficeDetail.Fnature > 1">
            <label for="Fclubexp">校园经历：</label><textarea name="Fclubexp" id="Fclubexp" :placeholder="'此处请填写您的校园经历，如：\n1、2017年6月-2017年8月，在XXX学校XX组织集体，担任XXX一职，主要工作内容是XXX，取得XXX成果。\n2、2018年6月-2018年8月，在XXX学校XX组织集体，担任XXX一职，主要工作内容是XXX，取得XXX成果。\n注意：如没有，请填写无'" class="focusText" :class="{error: ruleObj.FclubexpStatus}" v-model="submitForm.Fclubexp" @blur="checkRules('Fclubexp')" @input="checkRules('Fclubexp')"></textarea>
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FclubexpStatus">请输入校园经历</div>
            </transition>
          </div>
          <div v-show="submitOfficeDetail.Fnature > 1">
            <label for="Fawardexp">获奖情况：</label><textarea name="Fawardexp" id="Fawardexp" :placeholder="'此处请填写您的工作经历，如：\n1、2017年6月-2017年8月，在XXX学校（组织），参加XXX比赛，主要负责XXX，取得XXX奖励。\n2、2018年6月-2018年8月，在XXX学校（组织），参加XXX比赛，主要负责XXX，取得XXX奖励。\n注意：如没有，请填写无'" class="focusText" :class="{error: ruleObj.FawardexpStatus}" v-model="submitForm.Fawardexp" @blur="checkRules('Fawardexp')" @input="checkRules('Fawardexp')"></textarea>
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FawardexpStatus">请输入获奖情况</div>
            </transition>
          </div>
          <div>
            <label for="Feduexp">教育经历：</label><textarea name="Feduexp" id="Feduexp" :placeholder="'此处请填写您的教育经历，如：\n1、2017年6月-2017年8月，在XXX学校，XXX专业，取得XXX成绩。\n2、2018年6月-2018年8月，在XXX学校，XXX专业，取得XXX成绩。\n注意：如没有，请填写无'" class="focusText" :class="{error: ruleObj.FeduexpStatus}" v-model="submitForm.Feduexp" @blur="checkRules('Feduexp')" @input="checkRules('Feduexp')"></textarea>
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FeduexpStatus">请输入教育经历</div>
            </transition>
          </div>
          <div>
            <label for="Fprojectexp">项目经历：</label><textarea name="Fprojectexp" id="Fprojectexp" :placeholder="'此处请填写您的项目经历，如：\n1、2017年6月-2017年8月，参与了XXX项目，负责XXX模块内容，取得XXX成果。\n2、2018年6月-2018年8月，参与了XXX项目，负责XXX模块内容，取得XXX成果。\n注意：如没有，请填写无'" class="focusText" :class="{error: ruleObj.FprojectexpStatus}" v-model="submitForm.Fprojectexp" @blur="checkRules('Fprojectexp')" @input="checkRules('Fprojectexp')"></textarea>
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FprojectexpStatus">请输入项目经历</div>
            </transition>
          </div>
          <div>
            <label for="Fselfdesc">自我评定：</label><textarea name="Fselfdesc" id="Fselfdesc" :placeholder="'此处请填写您的自我评定，如：\n1、为人诚实守信，工作认真负责。\n2、吃苦耐劳，热情稳重，具有团队精神。'" class="focusText" :class="{error: ruleObj.FselfdescStatus}" v-model="submitForm.Fselfdesc" @blur="checkRules('Fselfdesc')" @input="checkRules('Fselfdesc')"></textarea>
            <transition name="el-fade-in-enter">
              <div class="ruleTips" v-show="ruleObj.FselfdescStatus">请输入自我评定</div>
            </transition>
          </div>
        </div>
        <div v-show="submitForm.FresumeType == 'extfile'" class="extfile-resume">
          <input type="file" name="Fresume" id="Fresume" ref="uploadCom" @change="uploadComChange">
          <div class="uploadFile" @click="uploadFileClick">{{uploadFile.name?'重新上传':'上传简历'}}</div>
          <div class="uploadFileName">{{uploadFile.name}}</div>
          <div class="upfileTips">* 仅支持doc/docx/pdf/rar/zip格式，大小不超过5MB</div>
        </div>
        <div class="checkCode-container">
          <label for="checkCode" style="width: 110px;">验&nbsp;&nbsp;证&nbsp;&nbsp;码：</label><input type="text" name="checkCode" id="checkCode" class="focusText" :class="{error: ruleObj.FcodeStatus}" v-model="submitForm.Fcode" @blur="checkRules('Fcode')" @input="checkRules('Fcode')">
          <div class="checkcode-img" @click="getCheckCodeImg"><img :src="checkcodeImgSrc" alt="checkCode" srcset=""></div><span class="refresh-checkcode" @click="getCheckCodeImg">点击刷新</span>
          <transition name="el-fade-in-enter">
            <div class="ruleTips checkCodeError" v-show="ruleObj.FcodeStatus">请正确输入验证码</div>
          </transition>
        </div>
        <div class="btnArea">
          <div class="submit" @click="submitFormClick">投递简历</div>
          <div class="postOfficeBtn" style="background:#80DAFF" @click="returnJobList">返回职位详情</div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import axios from "axios";
import ChinaCity from "@/utils/ChinaCity";
import { Message, MessageBox } from "element-ui";
import { setTimeout } from "timers";
export default {
  name: "SubmitResume",
  computed: {
    cityList() {
      if (this.submitForm.Fprovince === "") {
        return [];
      } else {
        return ChinaCity["0_" + this.submitForm.Fprovince];
      }
    }
  },
  data() {
    return {
      submitOfficeDetail: {
        Fjobid: 0,
        Fname: "",
        Fworkplace: "",
        Fnature: 0
      },
      submitForm: {
        Fname: "",
        Fphone: "",
        Fmail: "",
        Feducation: "",
        Fprovince: "",
        Fcity: "",
        Fworkplace: "",
        Fschool: "",
        Fmajor: "",
        FresumeType: "online", //online在线简历；extfile附件简历
        Fworkexp: "",
        Feduexp: "",
        Fprojectexp: "",
        Fselfdesc: "",
        Finternnexp: "",
        Fclubexp: "",
        Fawardexp: "",
        Fresume: "",
        Fjobid: "",
        Fcode: ""
      },
      uploadFileConfig: {
        fileSizeMax: 1024 * 1024 * 1, // 上传最大文件大小 10MB
        fileTypeReg: /(\.doc|\.docx|\.pdf|\.rar|\.zip)$/
      },
      ChinaCity: ChinaCity,
      provinceList: ChinaCity[0],
      ruleObj: {
        FnameStatus: false,
        FmailStatus: false,
        FlocationStatus: false,
        FschoolStatus: false,
        FphoneStatus: false,
        FeducationStatus: false,
        FworkplaceStatus: false,
        FmajorStatus: false,
        FworkexpStatus: false,
        FeduexpStatus: false,
        FprojectexpStatus: false,
        FselfdescStatus: false,
        FinternnexpStatus: false,
        FclubexpStatus: false,
        FawardexpStatus: false,
        FcodeStatus: false
      },
      checkcodeImgSrc: "",
      canSubmit: 1,
      uploadFile: {
        name: ""
      }
    };
  },
  created() {
    this.getCheckCodeImg();
    if (localStorage.getItem("submitOfficeDetail")) {
      let submitOfficeDetail = JSON.parse(
        localStorage.getItem("submitOfficeDetail")
      );
      if (
        submitOfficeDetail.Fjobid ==
        this.$route.path.replace(/^(.+)\/(\d+)$/gi, "$2")
      ) {
        this.submitOfficeDetail.Fjobid = submitOfficeDetail.Fjobid;
        this.submitForm.Fjobid = submitOfficeDetail.Fjobid;
        this.submitOfficeDetail.Fdesc = submitOfficeDetail.Fdesc;
        this.submitOfficeDetail.Feducation = submitOfficeDetail.Feducation;
        this.submitOfficeDetail.Fexperience = submitOfficeDetail.Fexperience;
        this.submitOfficeDetail.Fname = submitOfficeDetail.Fname;
        this.submitOfficeDetail.Fnature = submitOfficeDetail.Fnature;
        this.submitOfficeDetail.Fpaymax = submitOfficeDetail.Fpaymax;
        this.submitOfficeDetail.Fpaymin = submitOfficeDetail.Fpaymin;
        this.submitOfficeDetail.Fptime = submitOfficeDetail.Fptime;
        this.submitOfficeDetail.Ftype = submitOfficeDetail.Ftype;
        this.submitOfficeDetail.Fworkplace = submitOfficeDetail.Fworkplace;
        this.submitOfficeDetail.Frequire = submitOfficeDetail.Frequire;
        this.submitOfficeDetail.internshipDays =
          submitOfficeDetail.internshipDays;
      } else {
        localStorage.removeItem("submitOfficeDetail");
        this.$router.push(
          this.$route.path.replace(
            /^(.+)\/submit-resume\/(\d+)$/gi,
            "$1/detail"
          )
        );
      }
    } else {
      this.$router.push(
        this.$route.path.replace(/^(.+)\/submit-resume\/(\d+)$/gi, "$1/detail")
      );
    }
  },
  methods: {
    getCheckCodeImg() {
      // 获取验证码图片
      axios
        .get("/api/recruit/code", { responseType: "arraybuffer" })
        .then(res => {
          this.checkcodeImgSrc =
            "data:image/png;base64," +
            btoa(
              new Uint8Array(res.data).reduce(
                (res, byte) => res + String.fromCharCode(byte),
                ""
              )
            );
        })
        .catch(() => {
          Message({
            showClose: true,
            message: "获取校验码出错",
            type: "error"
          });
        });
    },
    FprovinceChange() {
      this.submitForm.Fcity = 0;
      this.checkRules("Flocation");
    },
    uploadFileClick() {
      this.$refs.uploadCom.click();
    },
    uploadComChange(event) {
      if (event.target.files.length > 0) {
        let fileInfo = event.target.files[0];
        let fileTypeReg = this.uploadFileConfig.fileTypeReg;
        let fileSizeMax = this.uploadFileConfig.fileSizeMax; // 最大5MB
        if (!fileTypeReg.test(fileInfo.name)) {
          this.$refs.uploadCom.value = "";
          Message({
            showClose: true,
            message: "请上传doc/docx/pdf/rar/zip格式文件",
            type: "error"
          });
          return false;
        } else {
          if (fileInfo.size > fileSizeMax) {
            this.$refs.uploadCom.value = "";
            Message({
              showClose: true,
              message:
                "上传的文件超过" + parseInt(fileSizeMax / 1024 / 1024) + "MB",
              type: "error"
            });
            return false;
          } else {
            this.submitForm.Fresume = fileInfo;
            this.uploadFile.name = fileInfo.name;
            Message({
              showClose: true,
              message: "上传" + fileInfo.name + "文件成功",
              type: "success"
            });
          }
        }
      }
    },
    async submitFormClick() {
      if (this.checkRules("All")) {
        if (this.canSubmit === 1) {
          this.canSubmit = 0;
          setTimeout(() => {
            this.canSubmit = 1;
          }, 4000);
          let reqData = JSON.parse(JSON.stringify(this.submitForm));
          reqData.Fworkexp = reqData.Fworkexp.replace(/\n/gm, "<br/>");
          reqData.Feduexp = reqData.Feduexp.replace(/\n/gm, "<br/>");
          reqData.Fprojectexp = reqData.Fprojectexp.replace(/\n/gm, "<br/>");
          reqData.Fselfdesc = reqData.Fselfdesc.replace(/\n/gm, "<br/>");
          reqData.Finternnexp = reqData.Finternnexp.replace(/\n/gm, "<br/>");
          reqData.Fclubexp = reqData.Fclubexp.replace(/\n/gm, "<br/>");
          reqData.Fawardexp = reqData.Fawardexp.replace(/\n/gm, "<br/>");
          reqData.Fresume = this.submitForm.Fresume;
          reqData.Fprovince = this.ChinaCity[0][reqData.Fprovince];
          reqData.Fcity = this.cityList[reqData.Fcity];
          let res = await this.$apis.reqToSubmitResume(reqData);
          if (res.rc === 0) {
            MessageBox.confirm("投递成功，点击确定跳转到首页", "简历投递", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "success",
              center: false
            })
              .then(() => {
                this.$router.push({ path: "/index" });
              })
              .catch(() => {
                Message({
                  type: "info",
                  message: "已取消跳转"
                });
              });
          } else {
            this.canSubmit = 1;
          }
        }
      }
    },
    checkRules(ruleName) {
      if (ruleName === "All") {
        let FnameStatus = this.checkRules("Fname");
        let FmailStatus = this.checkRules("Fmail");
        let FlocationStatus = this.checkRules("Flocation");
        let FschoolStatus = this.checkRules("Fschool");
        let FphoneStatus = this.checkRules("Fphone");
        let FeducationStatus = this.checkRules("Feducation");
        let FworkplaceStatus = this.checkRules("Fworkplace");
        let FmajorStatus = this.checkRules("Fmajor");
        let FworkexpStatus =
          this.submitOfficeDetail.Fnature === 1
            ? this.checkRules("Fworkexp")
            : true;
        let FinternnexpStatus =
          this.submitOfficeDetail.Fnature > 1
            ? this.checkRules("Finternnexp")
            : true;
        let FclubexpStatus =
          this.submitOfficeDetail.Fnature > 1
            ? this.checkRules("Fclubexp")
            : true;
        let FawardexpStatus =
          this.submitOfficeDetail.Fnature > 1
            ? this.checkRules("Fawardexp")
            : true;
        let FeduexpStatus = this.checkRules("Feduexp");
        let FprojectexpStatus = this.checkRules("Fprojectexp");
        let FselfdescStatus = this.checkRules("Fselfdesc");
        let FcodeStatus = this.checkRules("Fcode");
        if (this.submitForm.FresumeType == "extfile") {
          FworkexpStatus = true;
          FeduexpStatus = true;
          FprojectexpStatus = true;
          FselfdescStatus = true;
          FinternnexpStatus = true;
          FclubexpStatus = true;
          FawardexpStatus = true;
        }
        if (
          FnameStatus &&
          FmailStatus &&
          FlocationStatus &&
          FschoolStatus &&
          FphoneStatus &&
          FeducationStatus &&
          FworkplaceStatus &&
          FmajorStatus &&
          FworkexpStatus &&
          FeduexpStatus &&
          FprojectexpStatus &&
          FselfdescStatus &&
          FinternnexpStatus &&
          FclubexpStatus &&
          FawardexpStatus &&
          FcodeStatus
        ) {
          return true;
        } else {
          Message({
            type: "warning",
            message: "请检查填写信息"
          });
          return false;
        }
      } else if (ruleName === "Fmail") {
        let mailReg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
        if (mailReg.test(this.submitForm.Fmail)) {
          this.ruleObj[ruleName + "Status"] = false;
          return true;
        } else {
          this.ruleObj[ruleName + "Status"] = true;
          return false;
        }
      } else if (ruleName === "Fphone") {
        let phoneReg = /^1[3456789]\d{9}$/;
        if (phoneReg.test(this.submitForm.Fphone)) {
          this.ruleObj[ruleName + "Status"] = false;
          return true;
        } else {
          this.ruleObj[ruleName + "Status"] = true;
          return false;
        }
      } else if (ruleName === "Flocation") {
        if (this.submitForm.Fprovince !== "" && this.submitForm.Fcity !== "") {
          this.ruleObj[ruleName + "Status"] = false;
          return true;
        } else {
          this.ruleObj[ruleName + "Status"] = true;
          return false;
        }
      } else if (ruleName === "Fcode") {
        let checkCodeReg = /^\w{4}$/;
        if (checkCodeReg.test(this.submitForm.Fcode)) {
          this.ruleObj[ruleName + "Status"] = false;
          return true;
        } else {
          this.ruleObj[ruleName + "Status"] = true;
          return false;
        }
      } else {
        if (this.submitForm[ruleName] === "") {
          this.ruleObj[ruleName + "Status"] = true;
          return false;
        } else {
          this.ruleObj[ruleName + "Status"] = false;
          return true;
        }
      }
    },
    returnJobList() {
      // let routeUrl = this.$router.resolve({
      //   path: location.pathname.replace(/^(.*)\/detail\/(\d+)$/gi, "$1/detail")
      // });
      // // window.open(routeUrl.href, "_blank");
      // window.open(routeUrl.href, "_self");
      this.$router.push({
        path: location.pathname.replace(/^(.*)\/submit-resume\/(\d+)$/gi, "$1/detail/$2")
      });
    }
  }
};
</script>
<style scoped>
.submit-resume {
  font-size: 22px;
  color: #757575;
  max-width: 100%;
  margin: 0 auto;
}
.submit-resume .header .wantPost {
  width: 100%;
  max-width: 215px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 26px;
  color: #fff;
  font-weight: bold;
  border-radius: 30px;
  background: #16b3f3;
  margin: 0 auto;
}
.submit-resume .header .position {
  text-align: center;
  font-size: 22px;
  line-height: 52px;
}
.submit-resume form {
  width: 100%;
  max-width: 876px;
  margin: 20px auto 0;
}
.submit-resume form .baseinfo {
  /* min-height: 290px; */
  box-sizing: border-box;
  padding: 30px;
  border-radius: 25px;
  background: #f2faff;
}
.w_half {
  width: 50%;
  max-width: 498px;
  display: inline-block;
}
.w_half > div {
  display: flex;
  margin-bottom: 22px;
  align-items: center;
  position: relative;
}
label {
  min-width: 94px;
  height: 36px;
  line-height: 36px;
  display: inline-block;
}
.baseinfo input[type="text"] {
  border: 1px solid #eee;
  box-sizing: border-box;
  height: 36px;
  min-width: 240px;
  line-height: 34px;
  border-radius: 6px;
  padding-left: 8px;
  margin-left: 8px;
  color: #757575;
}
select {
  border: 1px solid #eee;
  box-sizing: border-box;
  height: 36px;
  min-width: 100px;
  line-height: 34px;
  border-radius: 6px;
  padding-left: 8px;
  margin: 0 8px;
  color: #757575;
  outline: none;
  /* appearance: none; */
  position: relative;
}
option {
  line-height: 34px;
  color: #757575;
  border-radius: 7px;
}
input::-webkit-input-placeholder {
  color: #eee;
  font-size: 18px;
}
input::-moz-input-placeholder {
  color: #eee;
  font-size: 18px;
}
input::-ms-input-placeholder {
  color: #eee;
  font-size: 18px;
}
#Feducation {
  width: 240px;
}
#Fworkplace {
  width: 202px;
}
select::after {
  content: "";
  width: 14px;
  height: 8px;
  position: absolute;
  top: 9px;
  right: 10px;
  z-index: 2;
  transition: all 0.2s ease-in-out;
  background: url("//udata.youban.com/webimg/xblhr/assets/icon/search.svg")
    no-repeat center center;
  background-size: contain;
}
.expInfo {
  margin-top: 30px;
  padding: 0px 10px 0 30px;
}
.expInfo > div.resume-type {
  display: inline-flex;
  align-items: center;
}
.expInfo > div.online-resume {
  margin-top: 40px;
}
.expInfo > div.online-resume > div {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  position: relative;
}
.expInfo > div.online-resume .ruleTips {
  right: 8px;
}
textarea {
  width: 720px;
  min-height: 200px;
  padding: 10px;
  font-size: 20px;
  line-height: 28px;
  color: #757575;
  border-radius: 7px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
input[type="radio"] {
  width: 22px;
  height: 22px;
  margin-right: 8px;
  opacity: 0;
  position: absolute;
  left: 4px;
  top: 8px;
  z-index: 3;
}
.radio {
  display: inline-flex;
  align-items: center;
  height: 36px;
  line-height: 36px;
  margin-right: 44px;
  position: relative;
  padding-left: 32px;
}
.radio::before {
  content: "";
  width: 22px;
  height: 22px;
  border: 1px solid #bababa;
  border-radius: 50%;
  position: absolute;
  z-index: 2;
  box-sizing: border-box;
  top: 8px;
  left: 4px;
  background: #fff;
}
.radio.active::before {
  box-shadow: inset 0 0 0 4px #f4f4f4;
  background: #16b3f3;
}
textarea::-webkit-input-placeholder {
  color: #ccc;
  font-size: 18px;
}
textarea::-moz-input-placeholder {
  color: #ccc;
  font-size: 18px;
}
textarea::-ms-input-placeholder {
  color: #ccc;
  font-size: 18px;
}
.online-resume label {
  width: 110px;
}
.checkCode-container {
  display: flex;
  align-items: center;
  position: relative;
}
.checkCode-container > .checkcode-img {
  display: inline-block;
  /* width: 120px;
  height: 40px; */
  background: #d4d5cd;
  margin: 0 13px;
  cursor: pointer;
}
.checkCode-container .ruleTips {
  bottom: -20px;
  right: 610px;
}
.checkcode-img > img {
  width: auto;
  height: 36px;
}
.refresh-checkcode {
  text-decoration: underline #16b3f3;
  color: #16b3f3;
  display: inline-block;
  height: 36px;
  line-height: 36px;
  cursor: pointer;
}
#checkCode {
  border: 1px solid #bbb;
  box-sizing: border-box;
  height: 36px;
  width: 120px;
  line-height: 34px;
  border-radius: 6px;
  padding-left: 8px;
  color: #757575;
}
select.focusText:focus,
input.focusText:focus,
textarea.focusText:focus,
input#checkCode:focus {
  border: 1px solid #16b3f3;
}
select.error,
input.error,
textarea.error {
  border: 1px solid #f56c6c !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.submit {
  margin: 48px auto 0;
  width: 226px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  font-weight: bold;
  color: #fff;
  border-radius: 40px;
  background: #f76a2d;
  cursor: pointer;
}
.uploadFile {
  width: 140px;
  height: 44px;
  border-radius: 22px;
  font-size: 20px;
  color: #fff;
  text-align: center;
  background: #16b3f3;
  line-height: 44px;
  font-weight: bold;
  cursor: pointer;
  position: absolute;
  top: 0px;
  left: 114px;
}
.upfileTips {
  font-size: 15px;
  position: absolute;
  top: 50px;
  left: 114px;
}
.extfile-resume {
  position: relative;
  margin-top: 30px;
  margin-bottom: 38px;
  height: 70px;
}
#Fresume {
  opacity: 0;
}
.ruleTips {
  position: absolute;
  font-size: 12px;
  color: #f56c6c;
  bottom: -17px;
  right: 70px;
}
.uploadFileName {
  position: absolute;
  font-size: 16px;
  line-height: 44px;
  top: 0;
  left: 278px;
}
.btnArea {
  display: flex;
  justify-content: space-around;
}
.postOfficeBtn {
  width: 224px;
  height: 80px;
  line-height: 80px;
  color: #fff;
  text-align: center;
  border-radius: 40px;
  background: #f76a2d;
  font-weight: bold;
  cursor: pointer;
  margin: 48px auto 0;
}
</style>


